import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineHeapSnapshotMultiple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={19}
    fill="none"
    viewBox="0 0 16 19"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.284 8.209a.85.85 0 0 0 .622-.254.84.84 0 0 0 .257-.62.85.85 0 0 0-.254-.622.84.84 0 0 0-.62-.257.85.85 0 0 0-.622.254.84.84 0 0 0-.257.62q0 .367.254.622a.84.84 0 0 0 .62.257m.503 3.898 4.288-4.288a.573.573 0 0 0 0-.848.6.6 0 0 0-.427-.192.57.57 0 0 0-.42.192l-4.303 4.303a.54.54 0 0 0-.18.408.6.6 0 0 0 .194.425q.191.192.427.192a.57.57 0 0 0 .42-.192m3.924.529a.85.85 0 0 0 .622-.254.84.84 0 0 0 .257-.62.85.85 0 0 0-.254-.622.84.84 0 0 0-.62-.257.85.85 0 0 0-.622.254.84.84 0 0 0-.257.62q0 .366.254.623a.84.84 0 0 0 .62.256m2.486 3.044H4.803q-.606 0-1.045-.438a1.43 1.43 0 0 1-.438-1.045V1.483q0-.607.438-1.045T4.803 0h6.52q.293 0 .563.107.27.106.498.333l2.856 2.855a1.46 1.46 0 0 1 .44 1.061v9.84q0 .607-.438 1.046-.439.438-1.045.438m.284-11.068h-2.434a.95.95 0 0 1-.696-.284.95.95 0 0 1-.283-.695V1.199H4.803a.27.27 0 0 0-.195.089.27.27 0 0 0-.089.195v12.714q0 .106.09.195a.27.27 0 0 0 .194.089h9.394a.27.27 0 0 0 .195-.09.27.27 0 0 0 .089-.194zM1.483 19q-.607 0-1.045-.438A1.43 1.43 0 0 1 0 17.517V6.134a.58.58 0 0 1 .595-.6q.252 0 .428.172a.57.57 0 0 1 .176.427v11.384q0 .107.089.195a.27.27 0 0 0 .195.089h9.17a.58.58 0 0 1 .6.595.6.6 0 0 1-.173.428.57.57 0 0 1-.427.176z"
    />
  </svg>
);
export default SvgStreamlineHeapSnapshotMultiple;
